/**
 * defa.collections.temperatureAlerts
 * A Collection of TemperatureAlert
 * @version 1.2.0
 */
import TemperatureAlert from './model-temperature-alert';

const TemperatureAlerts = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : TemperatureAlert,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default TemperatureAlerts;